export default __webpack_public_path__ + "static/media/banner_evaluacion.7fd832e8.png";